module.exports = __webpack_public_path__ + "static/media/pickup_grey.a4afb4f5.svg";